import { Swiper, SwiperSlide } from "swiper/react";
import Footer from "../components/Footer";
import "../pages/Book/custom.css";

import * as Styles from "./Book/styles";
import faqs from "../data/faqs";
import privacy from "../data/privacy";

import Grid from "../components/Grid";
import React from "react";
import { useLocation } from "react-router-dom";
import {
  Wrapper,
  PageTitleWrapper,
  PageTitle,
  PageDescription,
  PageSection,
  ChapterTitle,
  Section,
  Content,
} from "./Book/modules/Text/styles";

function renderHtmlContent(content) {
  const elements = [];
  let currentElement = null;

  // Regular expression to match HTML tags and text content
  const tagRegex = /(<\/?[^>]+>)|([^<>]+)/g;
  let match;
  while ((match = tagRegex.exec(content)) !== null) {
    const [fullMatch, tag, text] = match;

    if (tag) {
      if (tag.startsWith("<a ")) {
        // Extract href and target from the <a> tag
        const hrefMatch = tag.match(/href=['"]([^'"]+)['"]/);
        const targetMatch = tag.match(/target=['"]([^'"]+)['"]/);
        const href = hrefMatch ? hrefMatch[1] : "#";
        const target = targetMatch ? targetMatch[1] : "_self";

        // Create a new <a> element and store it in currentElement
        currentElement = (
          <a key={elements.length} href={href} target={target}>
            {/* The text will be added later */}
          </a>
        );
      } else if (tag.startsWith("</a>")) {
        // Push the completed <a> element to elements
        elements.push(currentElement);
        currentElement = null;
      } else if (tag.startsWith("<strong>")) {
        // Create a new <strong> element and store it in currentElement
        currentElement = (
          <strong key={elements.length}>
            {/* The text will be added later */}
          </strong>
        );
      } else if (tag.startsWith("</strong>")) {
        // Push the completed <strong> element to elements
        elements.push(currentElement);
        currentElement = null;
      } else {
        // Handle other tags or unknown tags
        elements.push(<span key={elements.length}>{tag}</span>);
      }
    } else if (text) {
      // Handle text content
      if (currentElement) {
        // If there's an open <a> tag, complete it with the text
        elements.push(React.cloneElement(currentElement, { children: text }));
        currentElement = null; // Reset currentElement after using it
      } else {
        // Otherwise, just push the text as a <span>
        elements.push(<span key={elements.length}>{text}</span>);
      }
    }
  }

  return elements;
}

const NutsAndBolts = () => {
  // export default () => {
  return (
    <React.Fragment>
      <Styles.Wrapper id="moduleFooter" light>
        <Styles.ContentWrapper>
          <Wrapper style={{ marginTop: 0 }}>
            <Grid>
              <PageTitleWrapper
                id="faqs"
                style={{ gridColumn: "1/-1", paddingTop: "60px" }}
              >
                <PageTitle>FAQs</PageTitle>
              </PageTitleWrapper>
              <React.Fragment>
                {faqs.map((faq) => (
                  <Section>
                    <Grid fullwidth style={{ padding: 0 }}>
                      <ChapterTitle>{faq.question}</ChapterTitle>
                      <Content>
                        {[faq.answer, faq.answer2]
                          .filter(Boolean) // Filter out undefined or null answers
                          .map((answer, index) => (
                            <React.Fragment key={index}>
                              {index > 0 && <br />}
                              {index > 0 && <br />}
                              {renderHtmlContent(answer)}
                            </React.Fragment>
                          ))}
                      </Content>
                    </Grid>
                  </Section>
                ))}
              </React.Fragment>

              <PageTitleWrapper
                id="privacy-statement"
                style={{ gridColumn: "1/-1", paddingTop: "50px" }}
              >
                <PageTitle>Privacy Statement</PageTitle>
              </PageTitleWrapper>
              <React.Fragment>
                {privacy.map((p) => (
                  <Section>
                    <Grid fullwidth style={{ padding: 0 }}>
                      <ChapterTitle>{p.question}</ChapterTitle>
                      <Content>
                        {[
                          [p.answer, p.listTitle, p.listItems],
                          [p.answer2, p.listTitle2, p.listItems2],
                          [p.answer3, p.listTitle3, p.listItems3],
                          [p.answer4, p.listTitle4, p.listItems4],
                          [p.answer5, p.listTitle5, p.listItems5],
                          [p.answer6, p.listTitle6, p.listItems6],
                          [p.answer7, p.listTitle7, p.listItems7],
                          [p.answer8, p.listTitle8, p.listItems8],
                        ]
                          .filter(
                            ([answer, title, items]) => answer || title || items
                          )
                          .map(([answer, title, items], index) => (
                            <React.Fragment key={index}>
                              {answer && (
                                <React.Fragment>
                                  {index > 0 && <br />}
                                  {index > 0 && <br />}
                                  {renderHtmlContent(answer)}
                                </React.Fragment>
                              )}

                              {title && (
                                <React.Fragment>
                                  <br />
                                  <br />
                                  {title}
                                  <br />
                                  <br />
                                </React.Fragment>
                              )}

                              {Array.isArray(items) && (
                                <ul>
                                  {items.map((item, itemIndex) => (
                                    <li key={itemIndex}>{item}</li>
                                  ))}
                                </ul>
                              )}
                            </React.Fragment>
                          ))}
                      </Content>
                    </Grid>
                  </Section>
                ))}
              </React.Fragment>
              <PageTitleWrapper
                id="copyright"
                style={{ gridColumn: "1/-1", paddingTop: "50px" }}
              >
                <PageTitle>Copyright</PageTitle>
              </PageTitleWrapper>
              <React.Fragment>
                <Section>
                  <Grid fullwidth style={{ padding: 0 }}>
                    <Content>
                      Scriptures taken from the Holy Bible, New International
                      Version ®, NIV ® Copyright © 1973, 1978, 1984, 2011 by
                      Biblica, Inc.
                      <br /> <br />
                      Used with permission. All rights reserved worldwide.
                      <br /> <br />
                      The “NIV”, “New International Version”, “Biblica”,
                      “International Bible Society” and the Biblica Logo are
                      trademarks registered in the United States Patent and
                      Trademark Office by Biblica, Inc. Used with permission.
                      <br /> <br />
                      All other content if not otherwise stated is ©2021 Bible
                      for Life
                    </Content>
                  </Grid>
                </Section>
              </React.Fragment>
            </Grid>
          </Wrapper>
        </Styles.ContentWrapper>
      </Styles.Wrapper>
      <Footer />
    </React.Fragment>
  );
};

export default NutsAndBolts;
